import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import FeaturedCategories from './components/FeaturedCategories';
import RecommendedBrands from './components/RecommendedBrands';
import StatsSection from './components/StatsSection';
import LatestArticles from './components/LatestArticles';
import WhyChooseDomestic from './components/WhyChooseDomestic';
import FAQ from './components/FAQ';
import { Helmet } from './components/Helmet';

export default function Home() {
  return (
    <>
      <Helmet
        title="国产专区 | 优质国货精选汇聚，品质生活首选"
        description="国产专区汇聚国内顶尖品牌与优质国货商品，精选各类高性价比国产好物，支持国货、品质生活从这里开始。无论是国产美妆、国产数码、国产食品还是国产服饰，国产专区为您一站式呈现最值得信赖的国产品牌与产品。"
        keywords="国产专区,国产品牌推荐,优质国货精选,国货好物汇总,国产商品大全,支持国货购物,高性价比国产产品,国内品牌专场"
        canonicalUrl="https://www.guochanzhuanqu.cn/"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '国产专区 - 优质国货精选汇聚',
          'description': '国产专区汇聚国内顶尖品牌与优质国货商品，精选各类高性价比国产好物。',
          'url': 'https://www.guochanzhuanqu.cn/',
          'inLanguage': 'zh-CN',
          'isPartOf': {
            '@type': 'WebSite',
            'name': '国产专区',
            'url': 'https://www.guochanzhuanqu.cn/',
          },
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': '首页',
                'item': 'https://www.guochanzhuanqu.cn/',
              },
            ],
          },
        }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedCategories />
        <RecommendedBrands />
        <StatsSection />
        <LatestArticles />
        <WhyChooseDomestic />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}